import React from "react";
import { Container, Row, Col } from "shards-react";
import "./RestaurantLayout.css";

const RestaurantLayout = ({ children }) => (
  <div className="layoutContainer">
    <Container fluid>
      {/* <Row className="justify-content-center">
        <Col
          className="main-content p-2 text-center bg-white rounded shadow"
          lg={{ size: 10 }}
          md={{ size: 10 }}
          sm="12"
          tag="main"
        > */}
          {children}
        {/* </Col>
      </Row> */}
    </Container>
  </div>
);

export default RestaurantLayout;
